module.exports = __webpack_public_path__ + "static/media/licenta16.f6a322ee.png";